// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3nPpK","inputWrap":"CustomTip_inputWrap__1Osax"};